/* eslint-disable quote-props */
import { Box, Button, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React from "react";
import { VETCOVE_URL } from "../../../../../../config/params";
import { ReceiptIcon } from "../../../../../../components/Icons";
import { usePetStore } from "../../../../../../hooks/redux-hooks/pet-store/pet-store.service";
import { useVetCoveRedirect } from "../../../../../../hooks/useVetCoveRedirect";

interface PrescriptionsHeaderProps {
  petId: string;
  prescriptionsUrl?: string;
  onPetChange: (event: SelectChangeEvent<string>) => void;
}

const PrescriptionsHeader = ({ petId, prescriptionsUrl, onPetChange }: PrescriptionsHeaderProps) => {
  const { petList } = usePetStore();
  const { handleVetCoveLink } = useVetCoveRedirect();

  return (
    <Box className="flex items-center justify-between pt-4 pb-4">
      <Select className="min-w-[140px] h-[40px] bg-white" id="pet-select" value={petId} onChange={onPetChange}>
        <MenuItem value="all">All Pets</MenuItem>
        {petList?.map((pet) => (
          <MenuItem key={pet.id} value={pet.id}>
            {pet.name}
          </MenuItem>
        ))}
      </Select>
      <Button
        startIcon={<ReceiptIcon />}
        variant="contained"
        color="primary"
        sx={{
          padding: { xs: "0 24px", sm: "0 32px" },
          fontWeight: 600,
          height: "40px",
          "& .MuiButton-startIcon": {
            "& svg path": {
              transition: "stroke 0.2s ease",
            },
          },
          "&:hover": {
            "& svg path": {
              stroke: "white",
            },
          },
        }}
        onClick={() =>
          handleVetCoveLink(prescriptionsUrl ? `${prescriptionsUrl}/pet/prescriptions` : undefined, VETCOVE_URL)
        }
      >
        My Prescriptions
      </Button>
    </Box>
  );
};

export default PrescriptionsHeader;
